<template>
  <div
    class="w-full bg-black text-white lg:px-6 flex items-center justify-center lg:justify-start"
    :class="
      customisation.layout === 2
        ? 'cw-gradient p-6 px-8'
        : 'bg-black lg:py-0 p-4 lg:h-12'
    "
  >
    <!-- Desktop -->
    <div
      :class="smartMenuActive ? 'opacity-0' : ''"
      class="hidden lg:flex flex-wrap lg:flex-nowrap justify-between items-center w-full"
    >
      <div class="flex justify-between items-center w-full">
        <div class="flex items-center gap-12">
          <template v-if="customisation.layout !== 2">
            <button
              v-if="
                !user && customisation.layout !== 1 && customisation.menu !== 1
              "
              :class="btnClass"
              @click="showLoginModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>Login</span>
            </button>
            <button
              v-if="
                user && customisation.layout !== 1 && customisation.menu !== 1
              "
              :class="btnClass"
              @click="triggerLogOut"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>Logout</span>
            </button>
          </template>
          <h6 :class="customisation.layout === 2 ? 'text-sm' : ''">
            {{ currentYear }} {{ settings.profile_title }}. Powered by
            CareerWise ©.
          </h6>
        </div>

        <div class="flex items-center gap-2">
          <template v-if="customisation.layout === 2">
            <button v-if="!user" :class="btnClass" @click="showLoginModal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>Login</span>
            </button>
            <button v-if="user" :class="btnClass" @click="triggerLogOut">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>Logout</span>
            </button>

            <div class="mx-4 text-white font-semibold">|</div>
          </template>

          <button :class="btnClass" @click="showTermsModal">
            Terms of Use
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="block lg:hidden">
      <div class="flex py-2 justify-center lg:justify-center">
        <button v-if="!user" :class="btnClass" @click="showLoginModal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
              clip-rule="evenodd"
            />
          </svg>
          <span>Login</span>
        </button>
        <button v-if="user" :class="btnClass" @click="triggerLogOut">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
              clip-rule="evenodd"
            />
          </svg>
          <span>Logout</span>
        </button>
      </div>
      <div class="w-full py-2 flex justify-center items-center">
        <h6 class="text-center">
          {{ currentYear }} {{ settings.profile_title }}. Powered by CareerWise
          ©.
        </h6>
      </div>
      <div class="w-full py-2 flex justify-center items-center">
        <button
          :class="[btnClass, customisation.layout === 2 ? '' : 'bg-black']"
          @click="showTermsModal"
        >
          <h6>Terms of Use</h6>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shared } from '../../../../js/mixins/shared.js'
import { EventBus } from '../../../../js/plugins/event-bus.js'

export default {
  mixins: {
    shared,
  },

  data() {
    return {
      currentYear: new Date().getFullYear(),
      btnClass:
        'border-none flex justify-center items-center font-primary font-semibold py-0',
      smartMenuActive: false,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      user: 'shared/getUser',
      customisation: 'careerwise/getCustomisation',
    }),
  },

  mounted() {
    EventBus.$on('smartMenuStateChanged', (active) => {
      this.$set(this, 'smartMenuActive', active)
    })
  },

  methods: {
    showLoginModal() {
      EventBus.$emit('showModal', 'login')
    },

    triggerLogOut() {
      EventBus.$emit('showModal', 'logout')
    },

    showTermsModal() {
      EventBus.$emit('showModal', 'terms')
    },
  },
}
</script>
